var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-uploads-page"},[(_vm.isDeactivated)?_c('DeactivatedEmptyState',{attrs:{"title":"Upload Media"}}):_c('h1',[_vm._v("Upload Media")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }